let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5TK3U")).then(() => parcelRequire('55ZrE'));